import type { ExtendedEvent, ExtendedStore } from './types'

type ViewportType = {
  defaultZoom: number
  center: {
    lat: number
    lng: number
  }
}

type FinderSettings = {
  mobile: ViewportType
  desktop: ViewportType
}

interface ConfigInterface {
  settings: {
    amountInList: number
    panToZoom: number
    de: FinderSettings
    en: FinderSettings
    fr: FinderSettings
    es: FinderSettings
    it: FinderSettings
    dk: FinderSettings
  }
  countries: {
    [key: string]: string[]
    shared: string[]
  }
}

export const fondOfKidsStore: ExtendedStore & ExtendedEvent = {
  type: 'Feature',
  properties: {
    id: '2681',
    debitorenNr: '',
    name: 'FOND OF KIDS STORE',
    address: 'Brüsseler Platz 3',
    zip: '50674',
    city: 'Köln',
    country: ['Deutschland'],
    assortment: { translation: [] },
    phone: '0160/90931175',
    mail: 'storekoeln@fondof.de',
    addressSuffix: '',
    website: '',
    fax: '',
    events: [{ startAt: '', endAt: '' }],
    sprayer: [''],
    streetNr: '3',
  },
  geometry: {
    coordinates: {
      lat: 50.9382367,
      lng: 6.9349806,
    },
    distance: 0,
  },
}

const config: ConfigInterface = {
  settings: {
    amountInList: 12,
    panToZoom: 15,
    en: {
      mobile: {
        defaultZoom: 3.5,
        center: {
          lat: 54.1411649,
          lng: 5.6946446,
        },
      },
      desktop: {
        defaultZoom: 5.2,
        center: {
          lat: 54.1411649,
          lng: 5.6946446,
        },
      },
    },
    de: {
      mobile: {
        defaultZoom: 5.5,
        center: {
          lat: 51.1758057,
          lng: 10.4541194,
        },
      },
      desktop: {
        defaultZoom: 7,
        center: {
          lat: 51.149585,
          lng: 7.816419,
        },
      },
    },
    fr: {
      mobile: {
        defaultZoom: 5.5,
        center: {
          lat: 46.1106885,
          lng: 2.5911028,
        },
      },
      desktop: {
        defaultZoom: 6.83,
        center: {
          lat: 47.6813282,
          lng: 2.4936556,
        },
      },
    },
    dk: {
      mobile: {
        defaultZoom: 6,
        center: {
          lat: 56.23008,
          lng: 11.5425001,
        },
      },
      desktop: {
        defaultZoom: 8.12,
        center: {
          lat: 56.2285785,
          lng: 12.2604916,
        },
      },
    },
    es: {
      mobile: {
        defaultZoom: 5,
        center: {
          lat: 40.4380557,
          lng: -3.7619361,
        },
      },
      desktop: {
        defaultZoom: 7,
        center: {
          lat: 40.4380557,
          lng: -3.7619361,
        },
      },
    },
    it: {
      mobile: {
        defaultZoom: 6,
        center: {
          lat: 42.2397929,
          lng: 12.0779423,
        },
      },
      desktop: {
        defaultZoom: 7.12,
        center: {
          lat: 42.1587213,
          lng: 12.6212805,
        },
      },
    },
  },
  countries: {
    shared: ['DE', 'IT', 'ES', 'FR', 'AT', 'CH', 'BE', 'DK'],
    ergobag: ['LI', 'CZ', 'PL', 'HU', 'SE'],
    affenzahn: ['FI', 'LI', 'GR', 'BG'],
    satch: ['NL', 'LU', 'SE', 'BG'],
  },
}

export default config
